import { render, staticRenderFns } from "./pkIn.vue?vue&type=template&id=1383e4e7&scoped=true&"
import script from "./pkIn.vue?vue&type=script&lang=js&"
export * from "./pkIn.vue?vue&type=script&lang=js&"
import style0 from "./pkIn.vue?vue&type=style&index=0&id=1383e4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383e4e7",
  null
  
)

export default component.exports